import estyled from '@signal/theme/emotion'
import { getSpacingSelector } from '@signal/theme'

export const Wrapper = estyled.div`
  padding: ${getSpacingSelector(8)}px;
  margin: ${getSpacingSelector(8)}px;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Image = estyled.img`
  margin: ${getSpacingSelector(2)}px;
  width: 450px;
`
